export default function asPercent(x, decimals = 1) {
  const mult = Math.pow(10, decimals);
  return `${Math.round(x * 100 * mult) / mult}%`;
}
